// Copyright The Perses Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { Button } from '@mui/material';
import AddGroupIcon from 'mdi-material-ui/PlusBoxOutline';
import { InfoTooltip } from '@perses-dev/components';
import { ReactElement } from 'react';
import { TOOLTIP_TEXT, editButtonStyle } from '../../constants';
import { useDashboardActions } from '../../context';

export const AddGroupButton = (): ReactElement => {
  const { openAddPanelGroup } = useDashboardActions();

  return (
    <InfoTooltip description={TOOLTIP_TEXT.addGroup}>
      <Button
        startIcon={<AddGroupIcon />}
        onClick={openAddPanelGroup}
        aria-label={TOOLTIP_TEXT.addGroup}
        sx={editButtonStyle}
      >
        Panel Group
      </Button>
    </InfoTooltip>
  );
};
